import { createContext, useContext, useEffect, useState } from "react";
import api from '../services/api';
import { useAuth } from "../context/AuthContext"; // Import Auth Context to listen for login changes

const StatusContext = createContext();

export const StatusProvider = ({ children }) => {
  const [status, setStatus] = useState(null);
  const { user } = useAuth(); // Get the logged-in user from AuthContext

  useEffect(() => {
    if (!user) return; // Prevent fetching if the user is not logged in

    api.get("/applicants/distinctStatus")
      .then((response) => setStatus(response.data))
      .catch((error) => console.error("Error fetching status:", error));
  }, [user]); // Re-fetch when the user changes

  return <StatusContext.Provider value={status}>{children}</StatusContext.Provider>;
};

export const useStatuses = () => useContext(StatusContext);